/* The Butterfly Effect — wing-flap scheduler.
   Any inline SVG with class .bfe-flap holds its wings at rest (open) by default. When it first
   scrolls into view it flaps a short "opening" burst after [data-flap-delay] ms, then keeps
   flapping a smaller burst every [data-flap-interval] ms while it stays in view. Purely
   decorative — respects reduced motion (never flaps) and pauses when scrolled out of view.

   The SVG's SMIL animateTransform elements are authored begin="indefinite" (no autoplay); one
   authored "flap" (open -> fold -> open) runs 0.667s, so a burst of N flaps = N * 667ms, ending
   cleanly at the rest pose. */
(function () {
  var FLAP_MS = 667; // duration of one authored open->fold->open cycle
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function num(el, attr, dflt) {
    var v = parseInt(el.getAttribute(attr), 10);
    return isFinite(v) ? v : dflt;
  }

  function setup(svg) {
    var anims = svg.querySelectorAll('animateTransform');
    if (!anims.length) return;
    var delay = num(svg, 'data-flap-delay', 2000);
    var first = num(svg, 'data-flap-first', 2);
    var loop = num(svg, 'data-flap-loop', 3);
    var interval = num(svg, 'data-flap-interval', 15000);

    var busy = false, endTimer = null;
    function burst(flaps) {
      if (busy || flaps < 1) return;
      busy = true;
      for (var i = 0; i < anims.length; i++) { try { anims[i].beginElement(); } catch (e) {} }
      endTimer = setTimeout(function () {
        for (var j = 0; j < anims.length; j++) { try { anims[j].endElement(); } catch (e) {} }
        busy = false;
      }, flaps * FLAP_MS + 20);
    }

    var started = false, firstTimer = null, loopTimer = null, inView = false;

    function start() {
      if (started) return;
      started = true;
      firstTimer = setTimeout(function () {
        if (inView) burst(first);
        loopTimer = setInterval(function () { if (inView) burst(loop); }, interval);
      }, delay);
    }

    if (!('IntersectionObserver' in window)) { inView = true; start(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        inView = e.isIntersecting;
        if (inView) start();
      });
    }, { threshold: 0.25 });
    io.observe(svg);
  }

  function init() {
    if (reduce) return; // leave wings at rest, no flapping
    var flies = document.querySelectorAll('.bfe-flap');
    for (var i = 0; i < flies.length; i++) setup(flies[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
